import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Message, MenuItem } from 'primeng/components/common/api';
import { SelectItem } from "primeng/components/common/selectitem";
import { UserService } from "../../../services/user/user.service";
import { StorageService } from "../../../services/system/storage.service";
import { BusinessService as BusinessCategoryService } from "../../../services/business/business-category.service";
import { AuthenticationService } from "../../../services/authentication/authentication.service";
import { CreateBusinessProfile } from "../../../models/inModels/BusinessProfile";

@Component({
	selector: 'app-business-profile-create',
	templateUrl: './business-profile-create.component.html',
	styleUrls: ['./business-profile-create.component.css']
})
export class BusinessProfileCreateComponent implements OnInit {
	model: CreateBusinessProfile;
	loading = false;
	messages: Message[];
	categories: SelectItem[];
	selectedCategory;
	userId;
	uploading= false;
	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private userService: UserService,
		private auth: AuthenticationService,
		public storageService: StorageService,
		public businessService: BusinessCategoryService) {
		this.getCategories();
	}

	ngOnInit() {
		this.loading = true;

		this.route.paramMap.subscribe(params => {
			this.userId = params.get('Id');
		});

		this.businessService.getUsersProfile(this.userId).then(
			result => {
				this.model = new CreateBusinessProfile(result);
				this.model.UserId = this.userId;
				console.log(this.model);

				if (result.CategoryId !== null) {
					this.selectedCategory = {
						label: result.Category,
						value: result.CategoryId
					};
				}

				this.loading = false;
			},
			error => {
				this.loading = false;
				this.messages = [];
				this.messages.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	getCategories() {
		this.loading = true;
		this.businessService.getDropdownList().then(
			x => {
				console.log(x);
				this.categories = x;
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.messages = [];
				this.messages.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	goBack(): void {
		this.router.navigate(['/users']);
	}

	handleFile(event, property): void {
		var result = this.storageService.handleSuccess(event);
		console.log(result);
		this.model[property] = result.PublicId;
		this.uploading = false;
	}

	handleError(event): void {
		this.uploading = false;
		this.messages = [];
		this.storageService.handleError(event, this.messages);
	}

	viewDocument(property): void {
		window.open(`${this.storageService.viewUrl}/${this.model[property]}`, '_blank');
	}

	removeDocument(property): void {
		this.model[property] = null;
		this.uploading = false;
	}

	save() {
		this.model.DateTaxClearanceExpires = this.auth.convertToUtc(this.model.DateTaxClearanceExpires);

		this.loading = true;
		this.businessService.createProfile(this.model).then(
			result => {
				this.loading = false;
				this.messages = [];
				this.messages.push({ severity: 'success', summary: 'Success', detail: "Profile Saved" });
			},
			error => {
				this.loading = false;
				this.messages = [];
				this.messages.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/business/business-profile/business-profile-create.component.ts